// extracted by mini-css-extract-plugin
export var actions = "_ri-4";
export var item = "_ri-1";
export var price = "_ri-3";
export var quantity = "_ri-2";
export var table = "_ri-0";